
import React, { useState,useEffect, Fragment } from "react";
// react component that copies the given text inside your clipboard
import { CopyToClipboard } from "react-copy-to-clipboard";
import { Route, Redirect, useHistory, BrowserRouter, Switch,NavLink as NavLinkRRD, Link } from "react-router-dom";
// reactstrap components
import {
    Card,
    Button,
    NavLink,
    CardHeader,
    CardBody,
    Container,
    Row,
    Col,
    CardTitle,
    UncontrolledTooltip,
} from "reactstrap";
import axiosInstance from "./../../helpers/axiosInstance";
import ReactCircleModal from 'react-circle-modal';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { DateRangePicker } from 'react-date-range';
import Slicer from 'react-slicer'
import 'react-slicer/build/react-slicer.css'
import basePerfiles from './basePerfiles.js'

const AdmPErfil = props => {
    console.log(props);
    const [perfiles,setperfiles]=useState(basePerfiles);
    const [moduloSelec,setmoduloSelec]=useState("");
    const [idperfilSelec,setidperfilSelec]=useState(0);
    const [accountNumber,setaccountNumber]=useState(props.location.state.accountNumber);
    useEffect(()=>{
        console.log(perfiles);
    },perfiles);
    const seleccionaperfil=(perf)=>{
        console.log(perf);
        setidperfilSelec(perf);
        
    }
    const seleccionaMod=(mod)=>{
        setmoduloSelec(mod);
    }
    
    const PermisosProducto=(props)=>{
        let modulo=props.modulo;
        let cabecera=[];
        let registros=[];
        if(props.listaPerfiles.length>0){
            for(let per=0;per<props.listaPerfiles.length;per++){
                if(props.listaPerfiles[per].id==props.id){
                    for(let i=0;i<props.listaPerfiles[per].permisos.length;i++){
                        if(props.listaPerfiles[per].permisos[i].mod==modulo && moduloSelec==modulo){
                            cabecera=props.listaPerfiles[per].permisos[i].habilidades;
                            registros.push(props.listaPerfiles[per].permisos[i].registros);
                        }
                    }
                }
            }   
        }
        
        console.log(registros);
        if(cabecera.length>0){
            return(
                <div>
                    <table>
                        <tr>
                            {cabecera.map(item=>{
                                return(
                                    <th className="col-md-2">{item}</th>
                                )
                            })}

                        </tr>
                        {registros.map((item,index)=>{
                            return(
                                <tr>
                                    {item[0].map(regi=>{
                                        return(
                                            <td>{regi}</td>
                                        )
                                    })}
                                </tr>
                            )
                        })}
                        
                    </table>
                </div>
            );

        }else{
            return(<div>

            </div>)
        }
    }
    const Editmodulos=(props)=>{
        let modul=["Productos de credito","Productos de ahorro","Deposito a termino","Opciones generales"]
        if(idperfilSelec>0){
            console.log("id seleccionado: " + idperfilSelec);
            return(
                <div className="ml-4 mt-2">
                    {modul.map(item=>{
                        
                    return(
                            <div >
                                <Row className="mt-3">
                                    <button className="btn btn-primary" onClick={()=>seleccionaMod(item)}>{item}</button>
                                    
                                </Row>  
                                <Row className="mt-3">
                                    
                                    <PermisosProducto listaPerfiles={perfiles} modulo={item} id={idperfilSelec}></PermisosProducto>
                                </Row>   

                            </div>
                        )
                    })}

                </div>
                
            )
        }else{
            return(
                <div></div>
            )
        }
        
    }
    const ListaPerfiles=(props)=>{
        if(props.listaPerfiles.length>0){
            return(
                <div>
                    <table >
                        <tr >
                            <th className="col-md-2 bg-green text-white font-weight-bold h3 ">
                                Id perfil
                            </th>
                            <th className="col-md-2 bg-green text-white font-weight-bold h3 ">
                                Descripción
                            </th>
                            <th className="col-md-2 bg-green text-white font-weight-bold h3 ">
                                Fecha último cambio
                            </th>
                            <th className="col-md-2 bg-green text-white font-weight-bold h3 ">
                                Usuario último cambio
                            </th>
                            <th className="col-md-2 bg-green text-white font-weight-bold h3 ">
                                Estado
                            </th>
                            <th className="col-md-2 bg-green text-white font-weight-bold h3 ">
                                Detalle
                            </th>
                        </tr>
                        {props.listaPerfiles.map((item,index)=>{
                            return(
                                <tr key={index}>
                                    <td className="col-md-1" >
                                        {item.id}
                                    </td>
                                    <td className="col-md-1">
                                        {item.nombrePerfil}
                                    </td>
                                    <td className="col-md-1">
                                        {item.fecha}
                                    </td>
                                    <td className="col-md-1">
                                        {item.ultimoUsuario}
                                    </td>
                                    <td className="col-md-1">
                                        {item.habilitado }
                                        
                                    </td>
                                    <td className="col-md-1">
                                        <button className="btn btn-primary" onClick={()=>seleccionaperfil(item.id)}>Detalle</button>
                                    </td>
                                </tr>
                            );

                        })}
                    </table>
                </div>
            );
        }else{
            return(
                <div></div>
            )
        }
    }
    return (
        <>
            <div className="pb-1 pt-1 pt-md-8">
                <Container fluid>
                    <div className="header-body">
                        <Card className="mb-xl-0 shadow pl-5 pr-5">
                            <Row className="row justify-content-center">
                                <div className="col-auto text-center">
                                    <h1 >Administración de perfiles</h1>
                                </div>
                                <div>
                                    <ListaPerfiles listaPerfiles={perfiles} ></ListaPerfiles>
                                </div>
                            </Row>
                            <Row className="row justify-content-center">
                                <Editmodulos ></Editmodulos>
                            </Row>
                        </Card>

                    </div>
                </Container>
            </div>
        </>
    )
}

export default AdmPErfil;
